import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  dividerLight: {
    backgroundColor: "#eeeeee"
  },
  dividerMain: {
    backgroundColor: "#797979"
  },
  controlButton: {
    padding: 0
  },
  listItem: {
    height: 68,
    paddingLeft: 24,
    paddingRight: 24,
    color: theme.palette.text.hint,
    position: "relative",
    [theme.breakpoints.down("md")]: {
      height: 78
    }
  },
  itemSelected: {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
    "& $icon": {
      color: theme.palette.text.primary
    }
  },
  listItemIcon: {
    minWidth: 40,
    position: "relative",
    color: theme.palette.text.hint,
    [theme.breakpoints.down("md")]: {
      minWidth: "100%"
    }
  },
  icon: {
    fontSize: 32,
    [theme.breakpoints.down("md")]: {
      minWidth: "auto",
      margin: "0 auto"
    }
  },
  listItemTextRoot: {
    [theme.breakpoints.down("md")]: {
      display: "none"
    },
    [theme.breakpoints.down("xs")]: {
      display: "block",
      fontSize: 18,
      color: theme.palette.text.secondary
    }
  },
  listItemText: {
    fontSize: 16,
    lineHeight: 1
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  shortMode: {},
  shortLayout: {
    position: "relative",
    top: "unset",
    bottom: "unset",
    right: "unset",
    left: "unset",
    borderRadius: "4px",
    width: "360px",
    backgroundColor: theme.palette.background.paper
  },
  shortLayoutContentContainer: {
    height: "calc(100vh - 100px)"
  },
  shortLayoutContentHeader: {
    position: "sticky",
    height: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  shortLayoutContentBody: {
    display: "flex",
    height: "calc(100% - 1px)"
  },
  managementLayout: {
    position: "absolute",
    top: 64,
    right: 0,
    bottom: 0,
    left: 220,
    border: `1px solid ${theme.palette.text.hint}`,
    backgroundColor: theme.palette.background.paper,
    "&:focus": {
      outline: "none"
    },
    [theme.breakpoints.down("md")]: {
      left: 84
    },
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      border: "none"
    }
  },
  managementContentContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%"
  },
  managementContentBody: {
    display: "flex",
    height: "100%",
    [theme.breakpoints.down(600)]: {
      flexDirection: "column",
      overflow: "auto"
    }
  },
  paper: {},
  headerPartLeft: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 1
  },
  headerItemText: {
    fontSize: 16,
    textAlign: "center",
    fontWeight: 600
  },
  headerPartRight: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    right: 12,
    top: 0,
    bottom: 0
  },
  regularSubheader: {
    height: 30,
    display: "flex",
    alignItems: "center"
  },
  regularSubLeft: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 1
  },
  regularSubRight: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexBasis: "40%",
    fontSize: 16,
    color: theme.palette.text.secondary
  },
  contentFooter: {},
  updatesNotification: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    position: "absolute",
    backgroundColor: theme.palette.warning.dark,
    top: "3px",
    right: "7px"
  },
  closeIcon: {
    fontSize: 28,
    "&:hover": {
      cursor: "pointer"
    }
  }
}));
